import React, { createContext, useContext, useState, useEffect } from "react";
import fondCarteImg from "../assets/tour/fondCarte.png";
import ordreCarteImg from "../assets/tour/ordreCarte.png";
import tourImg from "../assets/tour/tour.png";
import drawImg from "../assets/tour/drawCarte.png";
import exportImg from "../assets/tour/exportCarte.png";
import shareImg from "../assets/tour/shareCarte.png";
import tourEndImg from "../assets/tour/tourEnd.png";

//@ts-ignore
const TourContext = createContext();

const initTourSteps = [
  {
    tourId: "indicateurs",
    title: "🧭 Introduction au guide tour",
    description: (
      <div>
        <p>Ce guide interactif vous accompagne dans la découverte des indicateurs de risque disponibles sur le portail.</p>
        <p style={{ marginTop: 8 }}>
          À travers une série d'étapes, vous explorerez les principales fonctionnalités de cette section : comment consulter les indicateurs,
          comprendre leur signification, naviguer sur la carte, filtrer les données, et interpréter les résultats à différentes échelles
          territoriales.
        </p>
        <p style={{ marginTop: 8 }}>
          L'objectif ? Vous aider à mieux comprendre les{" "}
          <strong>facteurs qui rendent un territoire plus ou moins vulnérable face aux aléas climatiques</strong>, et à utiliser ces informations pour
          orienter les actions d'adaptation.
        </p>
        <p style={{ marginTop: 8 }}>👉 Cliquez sur “Suivant” pour commencer la visite.</p>
      </div>
    ),
    cover: <img alt="tour.png" src={tourImg} />,
    refId: null,
  },
  {
    tourId: "indicateurs",
    title: "Choisissez une thématique d’indicateurs",
    description: (
      <div>
        <p>
          Sur la gauche, vous trouvez le panneau latéral regroupant tous les <strong>indicateurs de risque</strong>.
        </p>
        <p style={{ marginTop: 8 }}>
          Ils sont organisés en plusieurs <strong>thématiques</strong> (ex. : Agriculture, Nature, Santé, etc.), afin de faciliter la navigation et la
          compréhension.
        </p>
        <p style={{ marginTop: 8 }}>
          Cliquez sur une thématique pour dérouler la liste des indicateurs qu’elle contient. Vous pouvez ensuite en sélectionner un pour l’afficher
          sur la carte et voir son détail.
        </p>
        <p style={{ marginTop: 8 }}>👉 Essayez de sélectionner une thématique pour continuer.</p>
      </div>
    ),
    placement: "right",
    refId: "side-panel",
  },
  {
    tourId: "indicateurs",
    title: "Explorez les cartes thématiques",
    description: (
      <div>
        <p>
          Chaque thématique regroupe plusieurs cartes que vous pouvez sélectionner et changer via un sélecteur. Vous pouvez également comparer deux
          cartes en choisissant une carte de comparaison de la même manière. Cela vous permet d’analyser facilement, par exemple, les effets d’un
          réchauffement à +2°C versus +4°C, ou d’observer simultanément deux phénomènes différents sur le territoire.
        </p>
        <p style={{ marginTop: 8 }}>N’hésitez pas à expérimenter pour mieux comprendre ces dynamiques.</p>
      </div>
    ),
    placement: "right",
    refId: "side-panel",
  },
  {
    tourId: "indicateurs",
    title: "🔍 Recherchez votre commune ou un lieu d’intérêt",
    description: (
      <div>
        <div>
          Utilisez la <strong>barre de recherche</strong> en haut de la carte pour trouver rapidement une <strong>commune</strong> ou un{" "}
          <strong>lieu spécifique</strong> en Wallonie.
        </div>
        <div style={{ marginTop: 8 }}>
          Il vous suffit de taper le nom d’un endroit (ex. : “Namur”, “Liège”, “Parc naturel des Hautes Fagnes”) : la carte se centrera
          automatiquement sur la zone sélectionnée et affichera les indicateurs disponibles pour ce territoire.
        </div>
        <div style={{ marginTop: 8 }}>
          Cette fonction vous permet de <strong>personnaliser votre exploration</strong> en vous concentrant sur des zones qui vous concernent
          directement.
        </div>
        <div style={{ marginTop: 8 }}>👉 Essayez d’entrer une commune dans la barre de recherche.</div>
      </div>
    ),
    placement: "left",
    refId: "searchbox",
  },
  {
    tourId: "indicateurs",
    title: "🛠️ Personnalisez et exportez vos cartes",
    description: (
      <div>
        Ce menu vous permet de personnaliser la carte (style et ordre des couches), de l’exporter, ou encore de dessiner vos propres éléments
        directement sur la carte.
      </div>
    ),
    placement: "left",
    refId: "settings",
  },
  {
    tourId: "indicateurs",
    title: "🌍 Fond de carte",
    description: (
      <div>
        Vous pouvez changer le fond de carte pour adapter la lisibilité à vos besoins : optez pour un fond neutre, une carte détaillée ou une vue
        satellite.
      </div>
    ),
    placement: "left",
    cover: <img alt="tour.png" src={fondCarteImg} />,
    refId: "settings-style",
  },
  {
    tourId: "indicateurs",
    title: "🃏 Ordre des couches",
    description: (
      <div>
        Vous pouvez définir l’ordre d’apparition de la carte thématique : choisissez de l’afficher au-dessus de tout ou de laisser les rues, bâtiments
        et labels visibles par-dessus.
      </div>
    ),
    placement: "left",
    cover: <img alt="tour.png" src={ordreCarteImg} />,
    refId: "settings-order",
  },
  {
    tourId: "indicateurs",
    title: "✍🏻 Dessiner sur la carte",
    description: (
      <div>
        Utilisez les outils de dessin pour ajouter des points, tracer des lignes ou dessiner des zones sur la carte. Ces éléments ne sont pas
        sauvegardés mais encodés dans l’URL, ce qui permet de les partager facilement.
      </div>
    ),
    placement: "left",
    cover: <img alt="tour.png" src={drawImg} />,
    refId: "settings-draw",
  },
  {
    tourId: "indicateurs",
    title: "⬇️ Exporter la carte",
    description: <div>Vous pouvez exporter la carte affichée au format image pour l’utiliser dans vos présentations, rapports ou documents.</div>,
    placement: "left",
    cover: <img alt="tour.png" src={exportImg} />,
    refId: "settings-export",
  },
  {
    tourId: "indicateurs",
    title: "Partager la carte",
    description: (
      <div>
        Générez un code à intégrer (iframe) pour afficher la carte directement sur un site tiers. C’est idéal pour inclure une vue personnalisée dans
        une page web ou un article.
      </div>
    ),
    placement: "left",
    cover: <img alt="tour.png" src={shareImg} />,
    refId: "settings-share",
  },
  {
    tourId: "indicateurs",
    title: "Explorez par vous-même",
    cover: <img alt="end" src={tourEndImg} />,
    description: (
      <div>
        Vous avez maintenant toutes les clés en main pour explorer la carte à votre rythme. Testez les différentes fonctionnalités et explorez les
        risques climatiques en Wallonie !
      </div>
    ),
  },

  {
    tourId: "projections",
    title: "Projections climatiques en Wallonie",
    description:
      "Cette page vous permet d'explorer les projections climatiques en Wallonie selon différents niveaux de réchauffement global (+2°C, +3°C ou +4°C). Les données sont basées sur des modèles récents et fiables.",
    refId: null,
  },
  {
    tourId: "projections",
    title: "Choix des indicateurs et temporalité",
    description:
      "Sélectionnez un indicateur climatique (température, précipitations…) ainsi que l’échelle de temps (annuelle, saisonnière ou mensuelle) pour visualiser les anomalies moyennes par rapport à 1981-2010.",
    refId: "projections-indicators",
  },
  {
    tourId: "projections",
    title: "Niveau de réchauffement",
    description:
      "Choisissez un niveau de réchauffement global parmi +2°C, +3°C ou +4°C pour explorer les impacts attendus selon différents futurs climatiques.",
    refId: "projections-scenario",
  },
  {
    tourId: "projections",
    title: "Données et méthodologie",
    description:
      "Les projections sont issues du modèle MAR basé sur 6 modèles CMIP6, selon les scénarios SSP370 et SSP585. Ce choix est aligné avec les recommandations du GIEC et de CORDEX-Europe.",
    refId: null,
  },
];

export const TourProvider = ({ children }) => {
  const [tour, setTour] = useState(null);
  const [tourSteps, setTourSteps] = useState(null);

  useEffect(() => {
    setTourSteps(
      //@ts-ignore
      tour ? initTourSteps.filter((d) => d.tourId === tour?.id).map((d, i) => ({ ...d, target: document.getElementById(d.refId) })) : null,
    );
  }, [tour]);

  //console.log("tourSteps", tour, tourSteps);
  return <TourContext.Provider value={[tour, setTour, tourSteps]}>{children}</TourContext.Provider>;
};

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error("useTour must be used within a TourProvider");
  }
  return context;
};
